import { Component, Vue, Watch } from 'vue-property-decorator';
import { NAV_MENU_LIST } from '@/utils/constants';
import { Route } from 'vue-router';
import { sessionService } from '@/providers/services/auth/session';
import { registryAPI } from '@/providers/apis/registry/registry';


@Component({ name: 'app-header-nav' })
export default class AppHeaderNav extends Vue {

  // -------------------------------------------------------------------------
  // Computed Properties

  private matchedRoute: any = [];
  private currentRoutePath: string = '/dashboard';

  @Watch('$route', { immediate: true, deep: true })
  public onUrlChange(newVal: Route) {
    this.matchedRoute = newVal.matched;
  }

  /**
   * Navigation menu items
   * @property {Array}
   */
  get menuItems() {
    return registryAPI.removeSelectedNavItem(NAV_MENU_LIST, this.isSuperUser);
  }

  public mounted() {
    this.currentRoutePath = this.$router.currentRoute.path;
  }
  get isSuperUser() {
    return sessionService.getSession()!.permissions.indexOf('ALL_ACCESS') !== -1;
  }

  get isShareableAccount() {
    return sessionService.getSession()!.isShareableLink;
  }

  get shareablePathName() {
    return sessionService.getSession()!.accessPath;
  }

  get isCompetency() {
    const item = window.localStorage.getItem('isCollab');
    const isCollab = item ? JSON.parse(item) : null;
    return isCollab ? isCollab.isCompetency : false;
  }

  get isResource() {
    const item = window.localStorage.getItem('isCollab');
    const isCollab = item ? JSON.parse(item) : null;
    return isCollab ? isCollab.isResource : false;
  }

  private onChangeRoute(currentPath: string) {
    this.currentRoutePath = currentPath;
    this.$router.push({ path: currentPath });
  }
  // -----------------------------------------------------------------------
  // Methods
  private getCurrentRoute(item: any) {
    return this.matchedRoute.find((route: any) => route.path === item);
  }

  private activeRoutes(item: any) {
    return !item.subMenu ? this.currentRoutePath.includes(item.path)
      : item.subMenu.find((path: any) => this.currentRoutePath.includes(path.path));
  }


}
